var _path, _rect, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 556,
    viewBox: "0 0 646 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.798 186.77H62.2568C27.8697 186.77 0 214.689 0 249.027V342.412C0 359.601 13.9397 373.541 31.1284 373.541H62.2568V466.926C62.2568 484.115 76.1965 498.054 93.3852 498.054H404.669C421.858 498.054 435.798 484.115 435.798 466.926V373.541H466.926C484.115 373.541 498.054 359.601 498.054 342.412V249.027C498.054 214.689 470.136 186.77 435.798 186.77ZM373.541 435.798H124.514V342.412H373.541V435.798ZM420.233 287.938C407.344 287.938 396.887 277.481 396.887 264.591C396.887 251.683 407.344 241.245 420.233 241.245C433.123 241.245 443.58 251.683 443.58 264.591C443.58 277.529 433.171 287.938 420.233 287.938ZM124.514 62.2568H347.763L373.541 88.0447V155.642H435.798V75.1459C435.798 66.893 432.515 58.9786 426.678 53.142L382.66 9.12451C376.848 3.28307 368.872 0 360.7 0H93.3852C76.2062 0 62.2568 13.9397 62.2568 31.1284V155.642H124.514V62.2568Z",
    fill: "#008393"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 285,
    width: 150,
    height: 150,
    fill: "#F5F6F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 360,
    r: 167.967,
    fill: "#F5F6F8",
    stroke: "#F5F6F8",
    strokeWidth: 55.9338
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310 360C310 282.672 372.672 220 450 220C527.328 220 590 282.672 590 360C590 437.328 527.328 500 450 500C372.672 500 310 437.328 310 360ZM405.703 333.805L431.461 359.508L405.703 385.703C400.617 390.844 400.617 399.156 405.703 403.805C410.844 409.383 419.156 409.383 423.805 403.805L449.508 378.539L475.703 403.805C480.844 409.383 489.156 409.383 493.805 403.805C499.383 399.156 499.383 390.844 493.805 385.703L468.539 359.508L493.805 333.805C499.383 329.156 499.383 320.844 493.805 315.703C489.156 310.617 480.844 310.617 475.703 315.703L449.508 341.461L423.805 315.703C419.156 310.617 410.844 310.617 405.703 315.703C400.617 320.844 400.617 329.156 405.703 333.805Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterOffline);
export default __webpack_public_path__ + "static/media/printer-offline.31e9eb35cd5e76fc3e32d7f90108fc14.svg";
export { ForwardRef as ReactComponent };